import { MILLISECONDS_IN_SECOND } from 'modules/tracking/config/constants';

export const SECONDS_IN_MINUTE = 60;
export const MINUTES_IN_HOUR = 60;
export const HOURS_IN_DAY = 24;

export const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * MINUTES_IN_HOUR; // 3600
export const SECONDS_IN_DAY = SECONDS_IN_HOUR * HOURS_IN_DAY; // 86400

export const UPDATE_INTERVAL_MS = SECONDS_IN_MINUTE * MILLISECONDS_IN_SECOND; // 60000
